import axios from "axios";

export const apiClient = axios.create({
  baseURL: "https://backoffice-demo.mamabear.co.id/api/",
  // baseURL: "http://127.0.0.1:8000/api/",
});
